import T from '../../Utils/Locale';
import { getGlobalState } from '../../Utils/GlobalState';
import isUserAuthenticated from '../../Utils/IsUserAuthenticated';
const PurchaseType = {
    DIGITAL: 'digital_document_basis',
    REVIEW: 'digital_document_review',
    ADVICE: 'digital_document_advice',
    REGISTRATION: 'registration',
    UPGRADE_TO_REVIEW: 'upgrade_to_review',
    UPGRADE_TO_ADVICE: 'upgrade_to_advice'
};
const firstUpgradeOption = () => {
    const user = getGlobalState('user');
    return isUserAuthenticated(user) ? PurchaseType.REVIEW : PurchaseType.ADVICE;
};
export const PurchaseTypeRank = {
    [PurchaseType.DIGITAL]: 1,
    [PurchaseType.REVIEW]: 2,
    [PurchaseType.ADVICE]: 3
};
export const shownType = {
    [PurchaseType.DIGITAL]: firstUpgradeOption(),
    [PurchaseType.REVIEW]: PurchaseType.ADVICE,
    [PurchaseType.ADVICE]: PurchaseType.ADVICE
};
export const getDefaultPurchaseType = () => {
    const user = getGlobalState('user');
    let preferredPurchaseType = isUserAuthenticated(user) ? PurchaseType.REVIEW : PurchaseType.ADVICE;
    // If the user has any partners, we'll loop through them, and see if there's any preferred purchase types among them
    if (isUserAuthenticated(user) && user.hasPartners) {
        preferredPurchaseType = prioritizePreferredPurchaseType(user);
    }
    return preferredPurchaseType;
};
export const getPurchaseTypes = () => {
    const allowedTypes = [PurchaseType.DIGITAL, PurchaseType.ADVICE];
    const user = getGlobalState('user');
    // If the user has an onboarding partner, allow the review purchase type to be selected.
    if (isUserAuthenticated(user)) {
        allowedTypes.splice(1, 0, PurchaseType.REVIEW);
    }
    return allowedTypes;
};
/**
 * Get the purchase types as an object ready for render as options in ComponentSelect.
 *
 * @param {string} productType
 * @param {boolean} addNoneOption
 * @param {string|null} selectedOption
 *
 * @return {object}
 *   The key is the PurchaseType and the value is the title.
 */
export const getPurchaseTypesAsSelectOptions = (addNoneOption = false, selectedOption = null) => {
    const options = {};
    const allowedTypes = [PurchaseType.DIGITAL, PurchaseType.ADVICE];
    const user = getGlobalState('user');
    if (addNoneOption) {
        options._none = T('purchase_type.choose');
    }
    // If the user has an onboarding partner, allow the review purchase type to be selected.
    if (shouldContainReview(user, selectedOption)) {
        allowedTypes.splice(1, 0, PurchaseType.REVIEW);
    }
    Object
        .values(PurchaseType)
        .filter((purchaseType) => allowedTypes.indexOf(purchaseType) > -1)
        .forEach((purchaseType) => {
        options[purchaseType] = T(`purchase_type.${purchaseType}`);
    });
    return options;
};
const shouldContainReview = (user, selectedOption) => {
    if (isUserAuthenticated(user)) {
        return true;
    }
    if (selectedOption && selectedOption === PurchaseType.REVIEW) {
        return true;
    }
    return false;
};
const prioritizePreferredPurchaseType = (user) => {
    const preferredPurchaseTypes = user.partners.map((partner) => {
        return partner.preferredPurchaseType;
    });
    if (preferredPurchaseTypes.includes(PurchaseType.REVIEW)) {
        return PurchaseType.REVIEW;
    }
    if (preferredPurchaseTypes.includes(PurchaseType.DIGITAL)) {
        return PurchaseType.DIGITAL;
    }
    return PurchaseType.ADVICE;
};
export default PurchaseType;
